<template>
  <div class="bags-of-different-materials with-slider">
    <!--type slider (desktop)-->
    <slider-select
      v-if="fields[BagsOfDifferentMaterialsFields.type].options?.length"
      v-model="form.type"
      class="main-slider"
    >
      <slider-select-option
        v-for="option in fields[BagsOfDifferentMaterialsFields.type].options"
        :key="option.value"
        :value="option.value"
        :label="option.title"
        :image-src="uploadsUrl(option?.thumbnail?.data?.attributes.url || '')"
      />
    </slider-select>
    <i-form
      v-scroll-to-invalid
      class="form"
      name="bags-of-different-materials-form"
      @submit="handleSubmit"
    >
      <div class="type">
        <strapi-label
          v-if="labels[BagsOfDifferentMaterialsLabels.type]"
          :label="labels[BagsOfDifferentMaterialsLabels.type]"
        />
        <div class="form-field-group">
          <!--type field-->
          <zaproo-select
            v-if="fields[BagsOfDifferentMaterialsFields.type]"
            v-model="form.type"
            :removable="false"
            name="type"
            searchable
            highlight
            :no-result-label="$t('No results found')"
            no-result-class="text-neutral-900/50 text-center !py-2 !px-4"
            :rules="fieldRules[BagsOfDifferentMaterialsFields.type]"
            :placeholder="$t('Select option')"
            dropdown-classes="py-2 mt-2"
            class="form-field checkmark"
          >
            <template #label>
              <special-order-form-input-label
                :field="fields[BagsOfDifferentMaterialsFields.type]"
              />
            </template>

            <zaproo-select-option
              v-for="option in fields[BagsOfDifferentMaterialsFields.type]
                .options"
              :key="option.value"
              :value="option.value"
              :label="option.title"
            />
          </zaproo-select>
        </div>
      </div>

      <div
        v-if="fields[BagsOfDifferentMaterialsFields.type].options?.length"
        class="form-slider"
      >
        <!--type slider (max to desktop)-->
        <slider-select v-model="form.type">
          <slider-select-option
            v-for="option in fields[BagsOfDifferentMaterialsFields.type]
              .options"
            :key="option.value"
            :value="option.value"
            :label="option.value"
            :image-src="
              uploadsUrl(option?.thumbnail?.data?.attributes.url || '')
            "
          />
        </slider-select>
      </div>

      <div class="dimensions mt-6">
        <strapi-label
          v-if="labels[BagsOfDifferentMaterialsLabels.dimensions]"
          :label="labels[BagsOfDifferentMaterialsLabels.dimensions]"
        />
        <div class="form-field-third">
          <!--length field-->
          <zaproo-input
            v-if="fields[BagsOfDifferentMaterialsFields.length]"
            v-model="form.length"
            type="number"
            name="length"
            :rules="fieldRules[BagsOfDifferentMaterialsFields.length]"
            :placeholder="
              fields[BagsOfDifferentMaterialsFields.length].placeholder
            "
            :description="
              fields[BagsOfDifferentMaterialsFields.length].description
            "
            class="form-field"
          >
            <template #label>
              <special-order-form-input-label
                :field="fields[BagsOfDifferentMaterialsFields.length]"
              />
            </template>
          </zaproo-input>

          <!--width field-->
          <zaproo-input
            v-if="fields[BagsOfDifferentMaterialsFields.width]"
            v-model="form.width"
            type="number"
            name="width"
            :rules="fieldRules[BagsOfDifferentMaterialsFields.width]"
            :placeholder="
              fields[BagsOfDifferentMaterialsFields.width].placeholder
            "
            :description="
              fields[BagsOfDifferentMaterialsFields.width].description
            "
            class="form-field"
          >
            <template #label>
              <special-order-form-input-label
                :field="fields[BagsOfDifferentMaterialsFields.width]"
              />
            </template>
          </zaproo-input>

          <!--folding field-->
          <zaproo-input
            v-if="fields[BagsOfDifferentMaterialsFields.folding]"
            v-model="form.folding"
            type="number"
            name="folding"
            :rules="fieldRules[BagsOfDifferentMaterialsFields.folding]"
            :placeholder="
              fields[BagsOfDifferentMaterialsFields.folding].placeholder
            "
            :description="
              fields[BagsOfDifferentMaterialsFields.folding].description
            "
            class="form-field"
          >
            <template #label>
              <special-order-form-input-label
                :field="fields[BagsOfDifferentMaterialsFields.folding]"
              />
            </template>
          </zaproo-input>
        </div>
      </div>

      <div class="material mt-6">
        <strapi-label
          v-if="labels[BagsOfDifferentMaterialsLabels.color]"
          :label="labels[BagsOfDifferentMaterialsLabels.color]"
        />
        <div class="form-field-group">
          <!--mainColor field-->
          <zaproo-input
            v-if="fields[BagsOfDifferentMaterialsFields.mainColor]"
            v-model="form.mainColor"
            name="mainColor"
            :rules="fieldRules[BagsOfDifferentMaterialsFields.mainColor]"
            :placeholder="
              fields[BagsOfDifferentMaterialsFields.mainColor].placeholder
            "
            :description="
              fields[BagsOfDifferentMaterialsFields.mainColor].description
            "
            class="form-field"
          >
            <template #label>
              <special-order-form-input-label
                :field="fields[BagsOfDifferentMaterialsFields.mainColor]"
              />
            </template>
          </zaproo-input>
        </div>
      </div>

      <div class="print mt-6">
        <strapi-label
          v-if="labels[BagsOfDifferentMaterialsLabels.print]"
          :label="labels[BagsOfDifferentMaterialsLabels.print]"
        />
        <div class="form-field-group">
          <!--numberOfPrintColorsFirstSide field-->
          <zaproo-select
            v-if="
              fields[
                BagsOfDifferentMaterialsFields.numberOfPrintColorsFirstSide
              ]
            "
            v-model="form.numberOfPrintColorsFirstSide"
            :removable="false"
            :rules="
              fieldRules[
                BagsOfDifferentMaterialsFields.numberOfPrintColorsFirstSide
              ]
            "
            :placeholder="$t('Select option')"
            dropdown-classes="py-2 mt-2"
            name="numberOfPrintColorsFirstSide"
            class="form-field checkmark"
          >
            <template #label>
              <special-order-form-input-label
                :field="
                  fields[
                    BagsOfDifferentMaterialsFields.numberOfPrintColorsFirstSide
                  ]
                "
              />
            </template>

            <zaproo-select-option
              v-for="option in fields[
                BagsOfDifferentMaterialsFields.numberOfPrintColorsFirstSide
              ].options"
              :key="option.value"
              :value="option.value"
              >{{ option.title }}</zaproo-select-option
            >
          </zaproo-select>

          <!--firstSidePrintArea field-->
          <zaproo-select
            v-if="
              isPrintColorsFirstSide &&
              fields[BagsOfDifferentMaterialsFields.firstSidePrintArea]
            "
            v-model="form.firstSidePrintArea"
            :removable="false"
            :rules="
              fieldRules[BagsOfDifferentMaterialsFields.firstSidePrintArea]
            "
            :placeholder="$t('Select option')"
            dropdown-classes="py-2 mt-2"
            name="numberOfPrintColorsFirstSide"
            class="form-field checkmark"
          >
            <template #label>
              <special-order-form-input-label
                :field="
                  fields[BagsOfDifferentMaterialsFields.firstSidePrintArea]
                "
              />
            </template>

            <zaproo-select-option
              v-for="option in fields[
                BagsOfDifferentMaterialsFields.firstSidePrintArea
              ].options"
              :key="option.title"
              :value="option.value"
              >{{ option.title }}</zaproo-select-option
            >
          </zaproo-select>
        </div>

        <div class="form-field-group">
          <!--numberOfPrintColorsSecondSide field-->
          <zaproo-select
            v-if="
              fields[
                BagsOfDifferentMaterialsFields.numberOfPrintColorsSecondSide
              ]
            "
            v-model="form.numberOfPrintColorsSecondSide"
            :removable="false"
            :rules="
              fieldRules[
                BagsOfDifferentMaterialsFields.numberOfPrintColorsSecondSide
              ]
            "
            :placeholder="$t('Select option')"
            dropdown-classes="py-2 mt-2"
            name="numberOfPrintColorsSecondSide"
            class="form-field checkmark"
          >
            <template #label>
              <special-order-form-input-label
                :field="
                  fields[
                    BagsOfDifferentMaterialsFields.numberOfPrintColorsSecondSide
                  ]
                "
              />
            </template>

            <zaproo-select-option
              v-for="option in fields[
                BagsOfDifferentMaterialsFields.numberOfPrintColorsSecondSide
              ].options"
              :key="option.value"
              :value="option.value"
              >{{ option.title }}</zaproo-select-option
            >
          </zaproo-select>

          <!--secondSidePrintArea field-->
          <zaproo-select
            v-if="
              isPrintColorsSecondSide &&
              fields[BagsOfDifferentMaterialsFields.secondSidePrintArea]
            "
            v-model="form.secondSidePrintArea"
            :removable="false"
            :rules="
              fieldRules[BagsOfDifferentMaterialsFields.secondSidePrintArea]
            "
            :placeholder="$t('Select option')"
            dropdown-classes="py-2 mt-2"
            name="numberOfPrintColorsSecondSide"
            class="form-field checkmark"
          >
            <template #label>
              <special-order-form-input-label
                :field="
                  fields[BagsOfDifferentMaterialsFields.secondSidePrintArea]
                "
              />
            </template>

            <zaproo-select-option
              v-for="option in fields[
                BagsOfDifferentMaterialsFields.secondSidePrintArea
              ].options"
              :key="option.value"
              :value="option.value"
              >{{ option.title }}</zaproo-select-option
            >
          </zaproo-select>
        </div>

        <div class="form-field-group">
          <!--designFile field-->
          <zaproo-file-input
            v-if="
              isPrintDesignFile &&
              fields[BagsOfDifferentMaterialsFields.designFile]
            "
            v-model="form.designFile"
            class="mt-3"
            name="designFiles"
            :rules="fieldRules[BagsOfDifferentMaterialsFields.designFile]"
            multiple
            :total-size-of-files="INPUT_FILE_TOTAL_SIZE"
            :placeholder="
              fields[BagsOfDifferentMaterialsFields.designFile].placeholder
            "
            file-item-classes="h-10"
            remove-button-classes="!p-0"
          >
            <template #label>
              <special-order-form-input-label
                :field="fields[BagsOfDifferentMaterialsFields.designFile]"
              />
            </template>
            <template #removeFileText>
              <icons-icon-trash />
              {{ $t("Remove") }}
            </template>
            <template #fileError="{ errors, clear }">
              <div class="mb-2 grid grid-cols-1 gap-2">
                <file-input-error-notification
                  :clear="clear"
                  :errors="errors"
                />
              </div>
            </template>
          </zaproo-file-input>
        </div>
      </div>

      <special-order-form-general-contacts-part
        v-model="form"
        class="general-contacts-form"
        :loading="loading"
      >
        <!--amountPcs field-->
        <zaproo-input
          v-if="fields[BagsOfDifferentMaterialsFields.amountPcs]"
          v-model="form.amountPcs"
          type="number"
          name="amountPcs"
          :rules="fieldRules[BagsOfDifferentMaterialsFields.amountPcs]"
          :placeholder="
            fields[BagsOfDifferentMaterialsFields.amountPcs].placeholder
          "
          :description="
            fields[BagsOfDifferentMaterialsFields.amountPcs].description
          "
          class="form-field"
        >
          <template #label>
            <special-order-form-input-label
              :field="fields[BagsOfDifferentMaterialsFields.amountPcs]"
            />
          </template>
        </zaproo-input>
      </special-order-form-general-contacts-part>
    </i-form>
  </div>
</template>

<script setup lang="ts">
import { Form as IForm, FormActions } from "vee-validate";
import SpecialOrderFormInputLabel from "../SpecialOrderFormInputLabel.vue";
import {
  BagsOfDifferentMaterialsFields,
  BagsOfDifferentMaterialsLabels,
} from "./types";
import {
  type StrapiField,
  type StrapiLabel as StrapiLabelType,
  type StrapiSpecialOrders,
} from "~/types/strapi";

import StrapiLabel from "~/components/strapi/components/shared/StrapiLabel.vue";
import SliderSelect from "~/modules/special-orders/components/SliderSelect/SliderSelect.vue";
import SliderSelectOption from "~/modules/special-orders/components/SliderSelect/SliderSelectOption.vue";
import FileInputErrorNotification from "~/modules/special-orders/components/SpecialOrderForm/FileInputErrorNotification.vue";
import { INPUT_FILE_TOTAL_SIZE } from "~/modules/special-orders/variables";
import { getFieldDefaultModel } from "~/modules/special-orders/helpers";
import { useFormFieldCleaner } from "~/modules/special-orders/composables/useFormFieldCleaner";

const props = defineProps<{
  specialOrder: StrapiSpecialOrders;
}>();

const { uploadsUrl } = useStrapiExtend();

const { collection: labelCollection } =
  useSpecialOrderUidDictionary<StrapiLabelType>(props.specialOrder.labels);

const { collection: fieldsCollection } =
  useSpecialOrderUidDictionary<StrapiField>(props.specialOrder.fields);

const { sendRequest, loading } = useSpecialOrdersSubmit(props.specialOrder);

const labels = computed(() => labelCollection(BagsOfDifferentMaterialsLabels));
const fields = computed(() => fieldsCollection(BagsOfDifferentMaterialsFields));
const fieldRules = useSpecialOrderFieldRules<
  typeof BagsOfDifferentMaterialsFields
>(fields.value);

const form = ref<ReturnType<typeof resetForm>>(resetForm());

const isPrintColorsFirstSide = computed(
  () => form.value.numberOfPrintColorsFirstSide !== "0",
);

const isPrintColorsSecondSide = computed(
  () => form.value.numberOfPrintColorsSecondSide !== "0",
);

const isPrintDesignFile = computed<boolean>(
  () => isPrintColorsFirstSide.value || isPrintColorsSecondSide.value,
);

function resetForm() {
  return {
    type: getFieldDefaultModel(
      fields.value[BagsOfDifferentMaterialsFields.type],
    ),
    length: getFieldDefaultModel(
      fields.value[BagsOfDifferentMaterialsFields.length],
    ),
    width: getFieldDefaultModel(
      fields.value[BagsOfDifferentMaterialsFields.width],
    ),
    folding: getFieldDefaultModel(
      fields.value[BagsOfDifferentMaterialsFields.folding],
    ),
    mainColor: getFieldDefaultModel(
      fields.value[BagsOfDifferentMaterialsFields.mainColor],
    ),
    numberOfPrintColorsFirstSide: getFieldDefaultModel(
      fields.value[BagsOfDifferentMaterialsFields.numberOfPrintColorsFirstSide],
    ),
    firstSidePrintArea: getFieldDefaultModel(
      fields.value[BagsOfDifferentMaterialsFields.firstSidePrintArea],
    ),
    numberOfPrintColorsSecondSide: getFieldDefaultModel(
      fields.value[
        BagsOfDifferentMaterialsFields.numberOfPrintColorsSecondSide
      ],
    ),
    secondSidePrintArea: getFieldDefaultModel(
      fields.value[BagsOfDifferentMaterialsFields.secondSidePrintArea],
    ),
    amountPcs: getFieldDefaultModel(
      fields.value[BagsOfDifferentMaterialsFields.amountPcs],
    ),
    designFile: [],
    email: "",
    phone: "",
    additionalInfo: "",
  };
}

async function handleSubmit(
  _: Record<string, unknown>,
  { resetForm: reset }: FormActions<Record<string, unknown>>,
) {
  await sendRequest(form.value);
  reset();
  form.value = resetForm();
}

useFormFieldCleaner(
  {
    designFile: {
      default: () => [],
      ref: isPrintDesignFile,
    },
    firstSidePrintArea: {
      default: () =>
        getFieldDefaultModel(
          fields.value[BagsOfDifferentMaterialsFields.firstSidePrintArea],
        ),
      ref: isPrintColorsFirstSide,
    },
    secondSidePrintArea: {
      default: () =>
        getFieldDefaultModel(
          fields.value[BagsOfDifferentMaterialsFields.secondSidePrintArea],
        ),
      ref: isPrintColorsSecondSide,
    },
  },
  form,
);
</script>
